import appboy from 'appboy-web-sdk';

import config from 'src/config';

class AppBoyClient {
  init() { //eslint-disable-line
    appboy.initialize(config.BRAZE_API_KEY, {
      enableLogging: config.NODE_ENV !== 'production',
      baseUrl: 'https://customer.iad-03.braze.com/api/v3'
    });
    appboy.display.automaticallyShowNewInAppMessages();
    appboy.openSession();
  }

  stopWebTracking() { //eslint-disable-line
    appboy.stopWebTracking();
  }

  resumeWebTracking() { //eslint-disable-line
    appboy.resumeWebTracking();
  }

  identify(user) { //eslint-disable-line
    appboy.changeUser(user.id);

    // appboy.getUser().setEmail(user.email);
    // appboy.getUser().setEmailNotificationSubscriptionType(user.unsubscribed ? 'unsubscribed' : 'opted_in');

    // this.updateNameAndGender(user);

    // if (user.phone) appboy.getUser().setPhoneNumber(user.phone);
    // if (user.birthday) appboy.getUser().setDateOfBirth(...getUserDOB(user).split('-'));

    // if (user.notes) appboy.getUser().setCustomUserAttribute('notes', user.notes);
    // if (user.membershipLevel) appboy.getUser().setCustomUserAttribute('membershipLevel', user.membershipLevel);
    // if (user.admin) appboy.getUser().setCustomUserAttribute('admin', user.admin);
    // if (user.initialClient) appboy.getUser().setCustomUserAttribute('initialClient', user.initialClient);
    // if (user.points) appboy.getUser().setCustomUserAttribute('points', user.points);
    // if (user.credit) appboy.getUser().setCustomUserAttribute('credit', user.credit);
    // if (user.totalPoints) appboy.getUser().setCustomUserAttribute('totalPoints', user.totalPoints);
    // if (user.banned) appboy.getUser().setCustomUserAttribute('banned', user.banned);
    // if (user.bookingCount) appboy.getUser().setCustomUserAttribute('bookingCount', user.bookingCount);
    // if (user.ticketCount) appboy.getUser().setCustomUserAttribute('ticketCount', user.ticketCount);
    // if (user.coverCount) appboy.getUser().setCustomUserAttribute('coverCount', user.coverCount);

    // this.updatePreferredCity(user);
  }

  // updateNameAndGender(user) { //eslint-disable-line
  //   appboy.getUser().setFirstName(user.firstName);
  //   appboy.getUser().setLastName(user.lastName);
  //
  //   if (user.gender) appboy.getUser().setGender(getUserGender(user));
  //   if (user.imageUrl) appboy.getUser().setAvatarImageUrl(user.imageUrl);
  // }
  //
  // updatePreferredCity(user) { //eslint-disable-line
  //   if (user.preferredCity) appboy.getUser().setCustomUserAttribute('preferredCity', user.location && user.location.preferred ? user.location.preferred.name : null);
  //   if (user.preferredCityId) appboy.getUser().setCustomUserAttribute('preferredCityId', user.location && user.location.preferred ? user.location.preferred.id : null);
  //   if (user.primaryCity) appboy.getUser().setCustomUserAttribute('primaryCity', user.location && user.location.primary ? user.location.primary.name : null);
  //   if (user.primaryCityId) appboy.getUser().setCustomUserAttribute('primaryCityId', user.location && user.location.primary ? user.location.primary.id : null);
  //   if (user.recentCity) appboy.getUser().setCustomUserAttribute('recentCity', user.location && user.location.recent ? user.location.recent.name : null);
  //   if (user.recentCityId) appboy.getUser().setCustomUserAttribute('recentCityId', user.location && user.location.recent ? user.location.recent.id : null);
  // }

  track(eventName, eventData) { //eslint-disable-line
    appboy.logCustomEvent(eventName, eventData);
  }
}

export default new AppBoyClient();



// WEBPACK FOOTER //
// ./src/services/appboy.js